import { combineReducers } from "redux";
import { Package } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  CREATE_PACKAGES_REQUEST,
  FETCH_PACKAGES_REQUEST,
  UPDATE_PACKAGES_STATUS_REQUEST,
  UPDATE_PACKAGES_WEIGHT_REQUEST,
} from "./constants";
import { Action } from "./types";

function items(state: Package[] = [], action: Action): Package[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_PACKAGES_REQUEST):
      return action.payload;

    case getSuccessActionType(CREATE_PACKAGES_REQUEST):
      return [...state, action.payload];

    case UPDATE_PACKAGES_WEIGHT_REQUEST:
    case UPDATE_PACKAGES_STATUS_REQUEST:
      return state.map((packageItem) =>
        packageItem.id === action.data.packagesId
          ? {
              ...packageItem,
              isFetching: true,
            }
          : packageItem
      );

    case getSuccessActionType(UPDATE_PACKAGES_WEIGHT_REQUEST):
    case getSuccessActionType(UPDATE_PACKAGES_STATUS_REQUEST):
      return state.map((packageItem) =>
        packageItem.id === action.data.packagesId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : packageItem
      );

    case getFailureActionType(UPDATE_PACKAGES_WEIGHT_REQUEST):
    case getFailureActionType(UPDATE_PACKAGES_STATUS_REQUEST):
      return state.map((packageItem) =>
        packageItem.id === action.data.packagesId
          ? {
              ...packageItem,
              isFetching: false,
            }
          : packageItem
      );

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_PACKAGES_REQUEST:
    case CREATE_PACKAGES_REQUEST:
      return true;

    case getSuccessActionType(FETCH_PACKAGES_REQUEST):
    case getFailureActionType(FETCH_PACKAGES_REQUEST):
    case getSuccessActionType(CREATE_PACKAGES_REQUEST):
    case getFailureActionType(CREATE_PACKAGES_REQUEST):
      return false;
    default:
      return state;
  }
}

export const packages = combineReducers({ items, isFetching });
